<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class='bid_item_title'><i class="fa fa-gavel"></i></span>
      <span class='bid_item_title'>Policies and Regulations</span>
      <el-button @click="moreLaw" class="bid_more" type="text">more<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </div>
    <div v-for="(nItem,index) in bidLawArr" :key="index" class="bid_note_item" @click="seeLawInfo(nItem.bidsId)">
      <el-row>
        <el-col :span="20">
          <span class="bid_common_item">{{nItem.title}}</span>
        </el-col>
        <el-col :span="4">{{nItem.time}}</el-col>
      </el-row>
    </div>
    <div v-show="isLawPage" class="bid_pagination">
      <el-pagination @current-change="pageTurn" :page-size="lPageSize" layout="prev, pager, next" :total="lPageNoSum">
      </el-pagination>
    </div>
  </el-card>
</template>
<script>
import { bidList } from '@/api/enFrontApi/bidding';
export default {
  data() {
    return {
      isLawPage: false,
      bidLawArr: [],
      lPageNoSum: 1,
      lPageSize: 10,
      lPageNo: 1
    };
  },
  created() {
    this.initLawData(1, 5, false);
  },
  methods: {
    initLawData(pageNo, pageSize, flag) {
      if (flag) this.isLawPage = flag;
      else this.isLawPage = false;
      bidList(pageNo, pageSize, 4).then(res => {
        this.bidLawArr = [];
        this.lPageNoSum = parseInt(res.data.pageTotal);
        this.bidLawArr = res.data.list;
      });
    },
    seeLawInfo(bidsId) {
      if (bidsId) {
        this.$router.push({
          name: 'iaic2019en/biddingInfo',
          params: {
            bidId: bidsId,
            itemNmae: ' Policies and Regulations'
          }
        });
      }
    },
    moreLaw() {
      this.$emit('sendBack', 5);
      this.initLawData(1, this.lPageSize, true);
    },
    sizeChangeCtl(val) {
      this.lPageSize = val;
      this.initLawData(this.lPageNo, this.lPageSize, true);
    },
    pageTurn(val) {
      this.lPageNo = val;
      this.initLawData(this.lPageNo, this.lPageSize, true);
    }
  }
};
</script>
<style lang="stylus" scoped>
.bid_note_item {
  height: 28px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/bidding/bidLaw.vue